import * as THREE from 'three';
import Store from '../Store';

export default class Annotations {
    constructor() {
        const { scene, camera, } = Store.getState();

        // Create your custom vertex and fragment shaders
        const vertexShader = `
varying vec2 vUv;  // Declare the varying variable

uniform vec3 viewVector;
uniform float c;
uniform float p;
varying float intensity;
void main() 
{
    vUv = uv;  // Assign the UV coordinates to the varying variable
    
    vec3 vNormal = normalize( normalMatrix * normal );
    vec3 vNormel = normalize( normalMatrix * viewVector );
    intensity = pow( c - dot(vNormal, vNormel), p );
    
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}
`;


        const fragmentShader = `
uniform sampler2D uTexture;
varying vec2 vUv;
uniform float uGlowRadius; // Radius of the glow effect

void main() {
    vec4 texColor = texture2D(uTexture, vUv);
    vec4 finalColor = texColor;
    float maxAlpha = 0.0;

    // Iterate through surrounding pixels to detect alpha
    for(float x = -uGlowRadius; x <= uGlowRadius; x += 0.01) {
        for(float y = -uGlowRadius; y <= uGlowRadius; y += 0.01) {
            vec4 neighborColor = texture2D(uTexture, vUv + vec2(x, y));
            maxAlpha = max(maxAlpha, neighborColor.a);
        }
    }

    // If surrounding pixels have some color (alpha > 0), apply glow
    if (maxAlpha > 0.1) {
        finalColor.rgb += vec3(0.5, 0.5, 0.5); // Adding glow by increasing RGB values. Adjust as needed.
    }

    gl_FragColor = finalColor;
}

    `;


        // Load the texture
        const textureLoader = new THREE.TextureLoader();
        textureLoader.load("https://static.mused.org/apophis.png", function(texture) {
            texture.minFilter = THREE.LinearFilter;

            // Create PlaneGeometry and Mesh
            const geometry = new THREE.PlaneGeometry(1, 1);
            const material = new THREE.ShaderMaterial({
                vertexShader: vertexShader,
                fragmentShader: fragmentShader,
                uniforms: {
                    uTexture: { value: texture },
                    uGlowRadius: { value: 0.05 },
                    glowColor: { type: "c", value: new THREE.Color(0xffffff) },
                    // ... any other uniforms you need
                },
                side: THREE.DoubleSide,
                transparent: true,
            });

            const plane = new THREE.Mesh(geometry, material);
            plane.position.set(3, 1.5, -5); // Set position as needed

            // Add to scene
            // scene.add(plane);
        });

        // Add mouse interaction
        // this.raycaster = new THREE.Raycaster();
        // this.mouse = new THREE.Vector2();
        // window.addEventListener('mousemove', this.onMouseMove.bind(this), false);
    }

    onMouseMove(event) {
        const { scene, camera, } = Store.getState();
        // calculate mouse position in normalized device coordinates
        // (-1 to +1) for both components
        this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

        // update the picking ray with the camera and mouse position
        this.raycaster.setFromCamera(this.mouse, camera);

        // calculate objects intersecting the picking ray
        const intersects = this.raycaster.intersectObjects([this.sphere]);

        if (intersects.length > 0) {
            // Change glow intensity
            this.sphereMaterial.uniforms.c.value = 1.2; // Increase glow intensity
        } else {
            this.sphereMaterial.uniforms.c.value = 1; // Reset glow intensity
        }
    }


    update() {
        const { scene, camera, } = Store.getState();
        // Update the uniform that requires it
        // this.sphereMaterial.uniforms.viewVector.value = new THREE.Vector3().subVectors(camera.position, this.sphere.position);
    }
}